import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CONFIG from "../config";

function Connect() {
  const navigate = useNavigate();
  const [connecting, setConnecting] = useState(false);
  const [form, setForm] = useState({
    hostname: "",
    username: "",
    password: "",
    protocol: "ssh",
  });
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleConnect = async (e) => {
    if (e) e.preventDefault();
    setConnecting(true);
    setError("");
    
    // Call backend to get token
    let token;
    try {
  const res = await fetch(`${CONFIG.API_BASE_URL}/api/generate-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Failed to get token");
      const data = await res.json();
      token = data.token;
    } catch (err) {
      setError("Failed to connect: " + err.message);
      setConnecting(false);
      return;
    }

    // Navigate to client page with token
    navigate(`/client#token=${encodeURIComponent(token)}`);
  };

  return (
    <div className="container">
      <form onSubmit={handleConnect} className="ssh-form">
        <h2>Connect With Credential</h2>
        <select
          name="protocol"
          value={form.protocol}
          onChange={handleInputChange}
          required
        >
          <option value="ssh">SSH</option>
          <option value="vnc">VNC</option>
          <option value="rdp">RDP</option>
        </select>
        <input
          type="text"
          name="hostname"
          placeholder="Hostname"
          value={form.hostname}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="username"
          placeholder="Username"
          value={form.username}
          onChange={handleInputChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleInputChange}
          required
        />
        <button id="connectButton" type="submit" disabled={connecting}>
          {connecting ? "Connecting..." : "Connect"}
        </button>
        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
}

export default Connect; 